// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-wrapper-table-published-cell .additional-text {
  margin-left: 5px;
  font-size: 12px;
  color: var(--fi-color-grey);
  transition: all 0.2s;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-wrapper-table/cells/fi-wrapper-table-published-cell/fi-wrapper-table-published-cell.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,oBAAA;AAAR","sourcesContent":[".fi-wrapper-table-published-cell {\r\n    .additional-text {\r\n        margin-left: 5px;\r\n        font-size: 12px;\r\n        color: var(--fi-color-grey);\r\n        transition: all 0.2s;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
